<template>
  <div class="pb-0 card-header text-start">
    <h4 style="text-align: center" class="font-weight-bolder">
      {{ data.title }}
    </h4>
    <p style="font-size: 13px; text-align: center" class="mb-0">
      {{ data.subTitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: "card-header",
  props: {
    data: {
      type: Object,
    },
  },
};
</script>